const ingredientDistanceThreshold = 0.5;

export function getIngredientsWithoutNutrition(recipe) {
  const result = [];
  
  recipe.ingredient_groups.forEach(group => {
    group.ingredients.forEach(ingredient => {
      let reason = null;
      
      if (!isMatchedIngredient(ingredient)) {
        reason = 'not_matched';
      } else if (ingredient.closest_ingredients[0].piece_weight == null && (ingredient.unit == 'piece' || ingredient.unit == 'none')) {
        reason = 'missing_piece_weight';
      } else if (ingredient.closest_ingredients[0].slice_weight == null && ingredient.unit == 'slice') {
        reason = 'missing_slice_weight';
      }
      
      if (reason) {
        result.push({ ingredient, reason });
      }
    });
  });

  return result;
}

export function getMatchedIngredients(recipe) {
  const matched = [];
  
  recipe.ingredient_groups.forEach(group => {
    group.ingredients.forEach(ingredient => {
      if (isMatchedIngredient(ingredient)) {
        matched.push(ingredient);
      }
    });
  });
  return matched;
}

export function isMatchedIngredient(ingredient) {
  return ingredient.closest_ingredients && 
         ingredient.closest_ingredients.length > 0 && 
         ingredient.closest_ingredients[0].distance < ingredientDistanceThreshold;
}
